module.exports = __webpack_public_path__ + "static/media/RobeetaLogo.5e9c6dd5.png";